
$(document).ready(function(){
  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav'
  });

  $('.slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: true,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true,
    verticalSwiping: true, 
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          vertical: false,
          verticalSwiping: false,
          slidesToShow: 4,
          swipeToSlide: true,
          draggable: true
        }
      },
      {
        breakpoint: 580,
        settings: {
          vertical: false,
          verticalSwiping: false,
          slidesToShow: 3,
          swipeToSlide: true,
          draggable: true
        }
      }
    ]
  });


  $('.single-product-media.single-product-media_with_thumbnail').addClass('opacity_1');

  $(document).on('click', '.dm-flip-card span.learn_more', function(){
    $(this).closest('.dm-flip-card').addClass('flip_card');
  });
  $(document).on('click', 'span.back_to_front_btn', function(){
    $(this).closest('.dm-flip-card').removeClass('flip_card');
  });
});
